import React, { useState, useEffect, useMemo, useRef } from 'react'
import Select from 'react-select'
import { SimpleFetch, SimpleFetchResponse, store } from '../../../../_helpers'
import { Card, ContentLoader } from '../../../../_components'
import { translateChannelName } from './_functions/translate'
import Webview from './_Webview'
import Notification, { notificationIntervalRecurrency } from './_Notification'
import { removeErrorDisplay } from '../../_functions'

const components = {
  "Webview": Webview,
  "Notificações push": Notification
}

export function Channel({data, setData, domain, errors, setErrors}) {
  const dataDispatcher = useMemo( () => {
    const filter = ( data.momentums ?? [] ).find( ( { type } ) => type === 'dispatcher' )
    return filter?.values?.[0]
  }, [ data ] )

  const firstDataDispatcher = useRef( dataDispatcher )

  const [ channels, setChannels ] = useState([])

  useEffect( () => {
    const data = firstDataDispatcher.current
    if ( !data ) return void 0
    if ( !channels?.length ) return void 0

    const channel = channels.find( channel => channel.raw_label === data.filter )

    setData( state => ( {
      ...state,
      dispatcher: data,
      raw_icon_uri: data.icon_uri ? { value: data.icon_uri } : undefined,
      raw_image: data.image ? { value: data.image } : undefined,
      raw_dispatcher_type: channel,
      raw_message: { value: data.message },
      raw_redirect_uri: { value: data.redirect_uri },
      raw_title: { value: data.title },
      raw_intervalRecurrency: data.intervalRecurrency?.map( intervalRecurrency => {
        let reducedIntervalRecurrency = Number( intervalRecurrency )
  
        const minimunIntervalQuery = Math.min( ...Object.values( notificationIntervalRecurrency ) )
        const dischargeInObject = {}
  
        while( reducedIntervalRecurrency > minimunIntervalQuery ) {
          // eslint-disable-next-line no-loop-func
          const intervalQueryPostfixKey = Object.keys( notificationIntervalRecurrency ).find( ( key ) => {
            const value = notificationIntervalRecurrency[key]
            if ( reducedIntervalRecurrency >= value ) return true
            return false
          } )
  
          const intervalQueryPostfixValue = notificationIntervalRecurrency[intervalQueryPostfixKey]
          reducedIntervalRecurrency -= intervalQueryPostfixValue
          dischargeInObject[intervalQueryPostfixKey] = ( dischargeInObject[intervalQueryPostfixKey] ?? 0 ) + 1
        }
  
        const query = Object.entries( dischargeInObject ).map( ( [ key, qty ] ) => `${qty}${key}` ).join( ' ' )

        return { label: query, value: query }
      } )
    } ) )
  }, [ setData, channels ] )

  useEffect(() => {
    async function getChannels() {
      if ( !domain ) domain = store.getState().changeDomainReducer.selectedDomain.domain_uuid

      const req = await SimpleFetch(`GET`, {}, {}, `main`, `domain/channels/${domain}`)
      if ( req.status !== 200 ) {
        SimpleFetchResponse(req, "Não foi possível listar os filtros disponíveis. Tente novamente mais tarde.", "Filtros disponíveis.")
      }

      let arr = []
      req.data.map(dispatcher => {
        if ( dispatcher.channel_type === "CELL_NOTIFICATION" ) {
          const label = translateChannelName(dispatcher.channel_type)
          arr.push({label, raw_label: dispatcher.channel_type, value: dispatcher.uuid})
        }
        
        return null
      })

      setChannels(arr)
    }
    getChannels()
  }, [])

  const handleChange = (e, type) => {
    if ( !e || !type ) return

    removeErrorDisplay(type, errors, setErrors)
    
    const raw = `raw_${type}`
    let arr = data.dispatcher ? data.dispatcher : [];

    if ( e.raw_label )
      return setData({...data, dispatcher: {...arr, [type]: e.value, filter: e.raw_label}, [raw]: e})

    setData({...data, dispatcher: {...arr, [type]: e.value}, [raw]: e})
  }

  return (
    <Card
      title="Canal"
      icon="BlocksIcon"
      description={"O Canal define um meio de comunicação por onde sua base será impactada, seja por Push Notifications, SMS ou até mesmo E-mail marketing."}
      required={true}
      help={"O Canal define um meio de comunicação por onde sua base será impactada, seja por Push Notifications, SMS ou até mesmo E-mail marketing."}
    >
      <div className="input__group">
        {
          channels && channels.length !== 0 ?
            <Select
              className={`
                selectable
                ${errors.dispatcherType && "selectable--error"}
              `}
              value={data.raw_dispatcher_type}
              options={channels}
              onChange={e => handleChange(e, 'dispatcher_type')}
              placeholder="Selecione o canal"
              noOptionsMessage={() =>"Nenhuma opção disponível"}
            />
          : <ContentLoader height="50px" spaceBetween={true}/>
        }
        
        {
          data.raw_dispatcher_type ? 
            function renderComponent() {
              const Component = components[data.raw_dispatcher_type.label]
              if ( !Component ) return null

              return <Component handleChange={handleChange} localData={data} setLocalData={setData} errors={errors} setErrors={setErrors} />
            }()
          : null
        }
      </div>
    </Card>
  )
}